export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 01 Mall Open.5f2ab136.mp3";